export const LOGGED_IN = "LOGGED_IN";
export const SET_USER = "SET_USER";
export const LOGGED_OUT = "LOGGED_OUT";
export const SET_FETCH_DATA = "SET_FETCH_DATA";
export const GET_USER_LOGGED_IN = "GET_USER_LOGGED_IN";
